<template>
  <div class="basket-coupon-interface">
    <b-overlay
      :show="loading"
      :rounded="false"
      :spinner-small="true"
      bg-color="white"
    >
      <b-input-group size="sm" v-if="basket.coupons.length === 0">
        <b-form-input
          v-model="coupon_code"
          placeholder="Enter discount code..."
          v-on:keyup.enter="applyCoupon"
        ></b-form-input>
        <b-input-group-append>
          <b-button variant="outline-success" @click="applyCoupon"
            >Apply</b-button
          >
        </b-input-group-append>
      </b-input-group>

      <div
        class="basket-coupon"
        :class="{ rtl }"
        v-for="(coupon, name) in basket.coupons"
        :key="name"
      >
        <div
          class="coupon-icon"
          @click="removeCoupon(name)"
          @mouseover="hover = true"
          @mouseleave="hover = false"
        >
          <svg
            class="bi"
            width="31px"
            height="31px"
            fill="currentColor"
            :class="{ 'd-none': hover }"
          >
            <use
              xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#bookmark-check-fill"
            />
          </svg>
          <svg
            class="bi coupon-remove"
            width="31px"
            height="31px"
            fill="currentColor"
            :class="{ 'd-none': !hover }"
          >
            <use
              xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#bookmark-x-fill"
            />
          </svg>
        </div>

        <div v-b-popover.top="coupon.desc">
          <div class="coupon-name">
            {{ name }}

            <svg
              class="bi"
              width="0.7rem"
              height="0.7rem"
              fill="currentColor"
              v-if="coupon.desc"
            >
              <use
                xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#info-circle"
              />
            </svg>
          </div>
          <div class="coupon-discount">
            {{ coupon.discount | currency }} Discount applied
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>


<script>
export default {
  data() {
    return {
      coupon_code: "",
      hover: false,
      loading: false,
    };
  },
  props: {
    rtl: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    basket() {
      return this.$store.state.basket;
    },
  },
  mounted() {},
  methods: {
    removeCoupon(code) {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to remove the discount code?", {
          okVariant: "danger",
          centered: true,
        })
        .then((val) => {
          if (val) {
            this.coupon_code = "";
            this.hover = false;
            this.loading = true;
            this.$store
              .dispatch("basket/remove_coupon", code)
              .then(() => {})
              .finally(() => {
                this.loading = false;
              });
          }
        });
    },
    applyCoupon() {
      this.hover = false;
      this.loading = true;
      this.$store
        .dispatch("basket/apply_coupon", this.coupon_code)
        .then((result) => {
          if (result.valid) {
            this.coupon_code = "";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>